module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain.8cd03d1d.svg";